import { request, Response } from '../utils';
import { Session } from '../types';

export const confirmEmail = (body: {
  username: string;
  emailConfirmationCode: string;
}): Response<{ session: Session }> => request('confirm-email', body);
